
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agent-advantage",
      function () {
        return require("private-next-pages/agent-advantage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agent-advantage"])
      });
    }
  